(() => {
  document.addEventListener('click', (event) => {
    if (!matchMedia('(max-width: 767px)').matches) return;
    const link = event.target.closest('[data-tx-event]');
    if (!link) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'tx_mobile_conversion',
      tx_action: link.dataset.txEvent,
      tx_path: location.pathname,
      tx_destination: link.getAttribute('href') || ''
    });
  }, { passive: true });

  const matchesWithin = (root, selector) => {
    if (!root) return [];
    const matches = [];
    if (root.nodeType === 1 && root.matches(selector)) matches.push(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach((item) => matches.push(item));
    return matches;
  };

  const fixMobileHelpPhone = (root = document) => {
    matchesWithin(root, '#item_mb_help a[href^="tel:"]').forEach((link) => {
      const visible = (link.textContent || '').replace(/\D/g, '');
      if (visible.endsWith('8326286375') || /0123456789/.test(link.getAttribute('href') || '')) {
        link.setAttribute('href', 'tel:+18326286375');
        link.setAttribute('aria-label', 'Call Texan Mattress Magnolia at 832-628-6375');
      }
    });
  };

  const cleanReviewTextNode = (node) => {
    if (!node || !node.nodeValue) return;
    node.nodeValue = node.nodeValue
      .replace(/480\+ 5-Star Google Reviews/g, '5-Star Google Reviews')
      .replace(/480\+ 5-Star Reviews/g, '5-Star Customer Reviews');
  };

  const cleanStaleReviewCounts = (root = document) => {
    const scope = root.nodeType === 9 ? root.body : root;
    if (!scope) return;
    if (scope.nodeType === 3) {
      cleanReviewTextNode(scope);
      return;
    }
    const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) cleanReviewTextNode(walker.currentNode);
  };

  const refresh = (root) => {
    fixMobileHelpPhone(root);
    cleanStaleReviewCounts(root);
  };

  const boot = () => {
    refresh(document);

    const pendingRoots = new Set();
    let queued = false;

    const flush = () => {
      queued = false;
      pendingRoots.forEach(refresh);
      pendingRoots.clear();
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 3) {
            if (/480\+ 5-Star/.test(node.nodeValue || '') && node.parentElement) {
              pendingRoots.add(node.parentElement);
            }
            return;
          }
          if (node.nodeType !== 1) return;

          const hasPhone = node.matches('#item_mb_help, #item_mb_help *') ||
            !!node.querySelector('#item_mb_help a[href^="tel:"]');
          const hasStaleReviewCount = /480\+ 5-Star/.test(node.textContent || '');
          if (hasPhone || hasStaleReviewCount) pendingRoots.add(node);
        });
      });

      if (!queued && pendingRoots.size) {
        queued = true;
        requestAnimationFrame(flush);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
